<template>
  <gat-alert-dialog
    :open="showDialog"
    title="Discard unsaved changes"
    text="You have unsaved changes. Are you sure you want to discard them?"
    :buttons="{
      ok: {
        text: 'Discard changes',
        variant: 'destructive',
        onClick: () => {
          unsavedChangesDialog.answerDialogPrompt('yes')
        }
      },
      cancel: {
        text: 'Cancel',
        variant: 'ghost'
      }
    }"
    @click:cancel="unsavedChangesDialog.answerDialogPrompt('no')"
  >
  </gat-alert-dialog>
</template>
<script setup lang="ts">
import { useUnsavedChangesDialog } from '@gat-ship/lib/router'
import { computed } from 'vue'

const unsavedChangesDialog = useUnsavedChangesDialog()

const showDialog = computed(() => unsavedChangesDialog.props.showDialog)
</script>
